import React from 'react'
import injectStyles from 'react-jss'

import { QUIZ_QUESTION_TYPES } from '../../../../shared/constants'

import styles from '../QuizQuestionItem/styles'
import { Input } from '../../../Form/Input/index'
import TrashCanV2 from '../../../../Assets/Images/icons/trashCanV2'
import RoundRadioButton from '../../../../Assets/Images/icons/roundRadioButton'
import SquareCheckBox from '../../../../Assets/Images/icons/squareCheckBox'

const QuizQuestionOption = ({
  index,
  type,
  onOptionChange,
  onDeleteOption,
  onChangeCorrectAnswer,
  isCorrectAnswer,
  onAddOption,
  value,
  classes,
}) => {
  const {
    item,
    input,
    checkBoxContainer,
    inputWithUnderline,
    questionCheckBox,
  } = classes

  const handleKeyPress = event => {
    const keyCode = event.which || event.keyCode
    if (keyCode === 13 || keyCode === 38) {
      onAddOption()
    }
  }

  return (
    <div className={item}>
      <Input
        onChange={e => onOptionChange({ text: e.target.value })}
        onKeyPressCapture={handleKeyPress}
        className={input}
        type="text"
        placeholder="Option"
        value={value}
        inputClassName={value.length > 0 ? input : inputWithUnderline}
      />

      <div className={questionCheckBox}>
        <div
          className={checkBoxContainer}
          onClick={() => onChangeCorrectAnswer()}
        >
          {type === QUIZ_QUESTION_TYPES.SINGLE_CHOICE ? (
            <RoundRadioButton active={isCorrectAnswer} />
          ) : (
            <SquareCheckBox active={isCorrectAnswer} />
          )}
        </div>
        <div className={classes.button} onClick={onDeleteOption}>
          <TrashCanV2 />
        </div>
      </div>
    </div>
  )
}

export default injectStyles(styles)(QuizQuestionOption)
